import React, { useEffect, useState } from 'react'
import { DatePicker, Space } from 'antd';
import cubejs from "@cubejs-client/core";
import { handleStateProspectQuery, handleStateOnboardQuery, handleStateCaseQuery } from './utils';
import MapTable from './MapTable';
import { dateFormat, getPreiviousDate } from './MyContribution';
import dayjs from 'dayjs'
import PersonWise from './PersonWise';
import { Radio } from 'antd';
const column = [
    {
        title: 'State',
        dataIndex: 'state',
        key: 'state',
        width: 200,
        fixed: 'left',

    },
    {
        title: 'City',
        dataIndex: 'city',
        key: 'city',
        width: 150,
        fixed: 'left',

    },
    {
        title: 'Prospect',
        dataIndex: 'pros_count',
        key: 'pros_count',
        width: 100,
        fixed: 'left',
    },


];


function MarketShare({ accessLevel, radioValue, modality }) {
    const [dateMonthRadio, setDateMonthRadio] = useState('date')
    const [onboardCount, setOnboardCount] = useState([])
    const [prospectCount, setProspectCount] = useState([])
    const [data, setData] = useState([])
    const [startDate, setStartDate] = useState(dateFormat(dayjs().startOf('month').toDate()))
    const [endDate, setEndDate] = useState(dateFormat(dayjs().endOf('month').toDate()))
    const [columns, setColumns] = useState([
    ])
    const [caseData, setCaseData] = useState([])
    const [caseCount, setCaseCount] = useState([])
    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = date.getDate();
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const monthIndex = date.getMonth();
        const year = date.getFullYear();

        const suffix = (day === 1 || day === 21 || day === 31) ? 'st' : (day === 2 || day === 22) ? 'nd' : (day === 3 || day === 23) ? 'rd' : 'th';

        return `${day}${suffix} ${monthNames[monthIndex]}`;
    }

    useEffect(() => {

        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
        if (accessLevel) {
            handleStateQueryProspect(cubejsApi)
        }

    }, [])

    useEffect(() => {
        const columnsFilled = dateMonthRadio === 'date' ? fillMissingDatesWithZeroCount([]) : transformData(fillMissingDatesWithZeroCount([]))

        const filledColumn = columnsFilled?.map(data => {
            return {
                title: dateMonthRadio === 'date' ? formatDate(data?.date) : data?.date,
                dataIndex: data?.date,
                key: data?.date,
                width: 100
            }
        })

        setColumns([...filledColumn])


    }, [startDate, endDate, dateMonthRadio])


    useEffect(() => {

        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
        if (accessLevel) {
            handleOboardQueryClient(cubejsApi, dateMonthRadio)
        }

    }, [startDate, endDate, dateMonthRadio])

    useEffect(() => {

        const cubejsApi = cubejs(
            process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA_TOKEN,
            {
                apiUrl: process.env.REACT_APP_MARKET_SHARE_GET_STATE_WISE_DATA,
            }
        );
        if (accessLevel) {
            handleCaseQueryClient(cubejsApi, dateMonthRadio)
        }

    }, [startDate, endDate, dateMonthRadio])

    const handleCaseQueryClient = async (cubejsApi, dateMonthRadio) => {

        try {
            await cubejsApi
                .load(handleStateCaseQuery(accessLevel?.name, getPreiviousDate(startDate), endDate, dateMonthRadio))
                .then((resultSet) => {
                    //    console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return {
                            state: data['Contribution.state'],
                            city: data['Contribution.city'],
                            date: data['Contribution.Date']?.split('T')?.[0],
                            onboard_count: data['Contribution.total_case_count']
                        }
                    })

                    const formatedData = formattedDateForOnboard(modifiedData)
                          
                    setCaseCount(formatedData)

                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }
    }


    const formattedDateForOnboard = (modifyData) => {
        const formatted = modifyData.reduce((acc, item) => {
            const existingItemIndex = acc.findIndex(elem => elem.state === item.state && elem.city === item.city);
            if (existingItemIndex !== -1) {
                acc[existingItemIndex].onboard.push({ date: item.date, onboard_count: item.onboard_count });
            } else {
                acc.push({
                    state: item.state,
                    city: item.city,
                    onboard: [{ date: item.date, onboard_count: item.onboard_count }]
                });
            }
            return acc;
        }, []);

        return formatted
    }

    const onChange = (date, dateString) => {
       
        const { start_date, end_date } = getMonthDates(dateString);

        setStartDate(start_date)
        setEndDate(end_date)
    };

    function getMonthDates(monthString) {
        const [year, month] = monthString.split('-').map(Number);
        const startDate = new Date(year, month - 1, 1); // Month is 0-based, so subtract 1
        const endDate = new Date(year, month, 1); // Set day to 1 of next month
        endDate.setDate(endDate.getDate() - 1);
        return { start_date: dateFormat(startDate), end_date: dateFormat(endDate) };
    }



    const handleOboardQueryClient = async (cubejsApi, dateMonthRadio) => {

        try {
            await cubejsApi
                .load(handleStateOnboardQuery(accessLevel?.name, getPreiviousDate(startDate), endDate, dateMonthRadio))
                .then((resultSet) => {

                    //    console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return {
                            state: data['Contribution.state'],
                            city: data['Contribution.city'],
                            date: data['Contribution.Onboarded_date']?.split('T')?.[0],
                            onboard_count: data['Contribution.client_count']
                        }
                    })

                    const formatedData = formattedDateForOnboard(modifiedData)
                    // console.log(formatedData)
                    setOnboardCount(formatedData)

                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }
    }

    const handleExtractDate = (onboardData) => {
        const dateDate = {}
        onboardData?.map(data => {

            dateDate[data?.date] = data?.onboard_count

        })
        return dateDate
    }

    const handleTableData = (data1) => {
        // fillMissingDatesWithZeroCount(data1)

        let filled = data1?.map(data => {
            if (dateMonthRadio === 'date') {
                return {
                    ...data,
                    onboard: fillMissingDatesWithZeroCount(data?.onboard)
                }
            } else {
                return {
                    ...data,
                    onboard: transformData(fillMissingDatesWithZeroCount(data?.onboard))
                }
            }
        })

      


        const modFilled = filled?.map(data => {

            return {
                state: data?.state,
                city: data?.city,
                pros_count: data?.pros_count,
                onboard: data?.onboard?.reduce((total, data) => total + parseInt(data?.onboard_count), 0),
                ...handleExtractDate(data?.onboard)
            }
        })


        return modFilled
        // setData(modFilled)
    }


    function getMonthName(dateString) {
        const date = new Date(dateString);
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        return monthNames[date.getMonth()];
    }

    // Function to transform the data into the desired format
    function transformData(data1) {
        const transformedData = {};

        data1.forEach(item => {
            const month = getMonthName(item.date);
            if (!transformedData[month]) {
                transformedData[month] = 0;
            }
            transformedData[month] += parseInt(item.onboard_count);
        });

        return Object.keys(transformedData).map(month => ({
            date: month,
            onboard_count: transformedData[month].toString()
        }));
    }







    const fillMissingDatesWithZeroCount = (data, selectedDate) => {
        const filledData = [];
        const start_Date = dateMonthRadio === 'date' ? new Date(dateFormat(startDate)) : new Date('2024-04-01');
        const end_Date = new Date(dateFormat(endDate)) > new Date() ? new Date() : new Date(dateFormat(endDate))
        let currentIndex = 0;

        let currentDate = new Date(start_Date);

        while (currentDate <= end_Date) {
            const dateString = currentDate.toISOString().split('T')[0];
            const existingEntry = data.find(item => item.date === dateString);

            if (existingEntry) {
                filledData.push(existingEntry);
            } else {
                filledData.push({ onboard_count: 0, date: dateString, });
            }

            currentDate.setDate(currentDate.getDate() + 1);
        }
        // console.log(filledData)
        // setFilledDates(filledData)
        return filledData;
    };

    const handleMergeData = (prospect, onboard) => {
        const mergedData = prospect?.map(onboardItem => {
            const matchingProsCountItem = onboard?.find(prosCountItem =>
                prosCountItem?.state === onboardItem?.state && prosCountItem?.city === onboardItem?.city
            );

            if (matchingProsCountItem) {
                return {
                    ...onboardItem,
                    ...matchingProsCountItem
                };
            } else {
                return { ...onboardItem, onboard: [] }
            }
        });

        return mergedData
    }

    useEffect(() => {
        if (prospectCount?.length > 0) {
            // console.log(handleMergeData(prospectCount,onboardCount))
            setData(handleMergeData(prospectCount, onboardCount))
        }

    }, [onboardCount, prospectCount])

    useEffect(() => {
        if (prospectCount?.length > 0) {

            setCaseData(handleMergeData(prospectCount, caseCount))
        }

    }, [caseCount, prospectCount])

    const onWeeklyChange = (e) => {
        setDateMonthRadio(e.target.value);
    };


    const handleStateQueryProspect = async (cubejsApi) => {

        try {
            await cubejsApi
                .load(handleStateProspectQuery(accessLevel?.name, getPreiviousDate(startDate), endDate))
                .then((resultSet) => {
                    //    console.log(resultSet)
                    const modifiedData = resultSet?.loadResponses[0]?.data?.map(data => {
                        return {
                            state: data['m_dashboard.state'],
                            city: data['m_dashboard.city'],
                            pros_count: data['m_dashboard.lead_count']
                        }
                    })

                    
                    setProspectCount(modifiedData)

                })
                .catch((error) => {
                    console.error("Error fetching API response:", error);
                });

        } catch (err) {

        }
    }
    return (
        <div style={{background:'white',height:'100vh',marginTop:'-20px',paddingTop:'20px'}}>
            {radioValue === 'state' ?
                <div>
                    <div style={{ padding: '0px 30px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                            <div style={{ fontSize: '20px', fontWeight: '700' }}>Onboard Count</div>
                            <div style={{ display: 'flex' }}>
                                <div>
                                    <Radio.Group style={{ width: '200px' }} onChange={onWeeklyChange} value={dateMonthRadio}>
                                        <Radio value={'date'}>By Date</Radio>
                                        <Radio value={'month'}>By Month</Radio>
                                    </Radio.Group>
                                </div>
                                <div>
                                    {dateMonthRadio === 'date' &&
                                        <DatePicker defaultValue={dayjs()} onChange={onChange} picker="month" />

                                    }
                                </div>
                            </div>
                        </div>
                        <MapTable data={handleTableData(data)} columns={[...column, {
                            title: 'New Install',
                            dataIndex: 'onboard',
                            key: 'onboard',
                            width: 110,
                            fixed: 'left',
                        }, ...columns]} />
                    </div>

                    <div style={{ padding: '0px 30px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                            <div style={{ fontSize: '20px', fontWeight: '700' }} >Cases Count</div>
                            <div>
                                {/* <DatePicker defaultValue={dayjs()} onChange={onChange} picker="month" /> */}
                            </div>
                        </div>
                        <MapTable data={handleTableData(caseData)} columns={[...column, {
                            title: 'Total Cases',
                            dataIndex: 'onboard',
                            key: 'onboard',
                            width: 110,
                            fixed: 'left',
                        }, ...columns]} />
                    </div>

                </div> :
                <PersonWise onChange={onChange} startDate={startDate} endDate={endDate} dateMonthRadio={dateMonthRadio}
                    fillMissingDatesWithZeroCount={fillMissingDatesWithZeroCount} onWeeklyChange={onWeeklyChange}
                    formatDate={formatDate} accessLevel={accessLevel} getPreiviousDate={getPreiviousDate} transformData={transformData}
                />
            }
        </div>
    )
}

export default MarketShare
